import 'react-app-polyfill/ie9'
import '@babel/polyfill'
import '@babel/core'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom'
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import zhTW from './locales/zh-TW';
import zhCN from './locales/zh-CN';
import zhEN from './locales/zh-EN';
import zhVN from './locales/zh-VN';
import zhTHAI from './locales/zh-THAI';
const resources = {
    zhCN: {
      translation: zhCN
    },
    zhTW: {
      translation: zhTW
    },
    zhEN:{
      translation: zhEN
    },
    zhVN: {
      translation: zhVN
    },
    zhTHAI:{
      translation: zhTHAI
    },
  };
  
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources,
      lng: "zhCN",
  
      keySeparator: false, // we do not use keys in form messages.welcome
  
      interpolation: {
        escapeValue: false // react already safes from xss
      }
    });

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
